import { Region } from './countriesConfig';

//Note: if for any reason there is necessity of modifying the names, please remember to check the production database to ensure everything is up to date
export const ITALIAN_REGIONS = [
    {
        name: 'Abruzzo',
        code: 'IT-65',
        provinces: [
            { name: "L'Aquila", code: 'AQ' },
            { name: 'Chieti', code: 'CH' },
            { name: 'Pescara', code: 'PE' },
            { name: 'Teramo', code: 'TE' },
        ],
    },
    {
        name: 'Basilicata',
        code: 'IT-77',
        provinces: [
            { name: 'Matera', code: 'MT' },
            { name: 'Potenza', code: 'PZ' },
        ],
    },
    {
        name: 'Calabria',
        code: 'IT-78',
        provinces: [
            { name: 'Cosenza', code: 'CS' },
            { name: 'Catanzaro', code: 'CZ' },
            { name: 'Crotone', code: 'KR' },
            { name: 'Reggio Calabria', code: 'RC' },
            { name: 'Vibo Valentia', code: 'VV' },
        ],
    },
    {
        name: 'Campania',
        code: 'IT-72',
        provinces: [
            { name: 'Avellino', code: 'AV' },
            { name: 'Benevento', code: 'BN' },
            { name: 'Caserta', code: 'CE' },
            { name: 'Napoli', code: 'NA' },
            { name: 'Salerno', code: 'SA' },
        ],
    },
    {
        name: 'Emilia-Romagna',
        code: 'IT-45',
        provinces: [
            { name: 'Bologna', code: 'BO' },
            { name: 'Forlì-Cesena', code: 'FC' },
            { name: 'Ferrara', code: 'FE' },
            { name: 'Modena', code: 'MO' },
            { name: 'Piacenza', code: 'PC' },
            { name: 'Parma', code: 'PR' },
            { name: 'Ravenna', code: 'RA' },
            { name: 'Reggio Emilia', code: 'RE' },
            { name: 'Rimini', code: 'RN' },
        ],
    },
    {
        name: 'Friuli-Venezia Giulia',
        code: 'IT-36',
        provinces: [
            { name: 'Gorizia', code: 'GO' },
            { name: 'Pordenone', code: 'PN' },
            { name: 'Trieste', code: 'TS' },
            { name: 'Udine', code: 'UD' },
        ],
    },
    {
        name: 'Lazio',
        code: 'IT-62',
        provinces: [
            { name: 'Frosinone', code: 'FR' },
            { name: 'Latina', code: 'LT' },
            { name: 'Rieti', code: 'RI' },
            { name: 'Roma', code: 'RM' },
            { name: 'Viterbo', code: 'VT' },
        ],
    },
    {
        name: 'Liguria',
        code: 'IT-42',
        provinces: [
            { name: 'Genova', code: 'GE' },
            { name: 'Imperia', code: 'IM' },
            { name: 'La Spezia', code: 'SP' },
            { name: 'Savona', code: 'SV' },
        ],
    },
    {
        name: 'Lombardia',
        code: 'IT-25',
        provinces: [
            { name: 'Bergamo', code: 'BG' },
            { name: 'Brescia', code: 'BS' },
            { name: 'Como', code: 'CO' },
            { name: 'Cremona', code: 'CR' },
            { name: 'Lecco', code: 'LC' },
            { name: 'Lodi', code: 'LO' },
            { name: 'Monza e della Brianza', code: 'MB' },
            { name: 'Milano', code: 'MI' },
            { name: 'Mantova', code: 'MN' },
            { name: 'Pavia', code: 'PV' },
            { name: 'Sondrio', code: 'SO' },
            { name: 'Varese', code: 'VA' },
        ],
    },
    {
        name: 'Marche',
        code: 'IT-57',
        provinces: [
            { name: 'Ancona', code: 'AN' },
            { name: 'Ascoli Piceno', code: 'AP' },
            { name: 'Fermo', code: 'FM' },
            { name: 'Macerata', code: 'MC' },
            { name: 'Pesaro e Urbino', code: 'PU' },
        ],
    },
    {
        name: 'Molise',
        code: 'IT-67',
        provinces: [
            { name: 'Campobasso', code: 'CB' },
            { name: 'Isernia', code: 'IS' },
        ],
    },
    {
        name: 'Piemonte',
        code: 'IT-21',
        provinces: [
            { name: 'Alessandria', code: 'AL' },
            { name: 'Asti', code: 'AT' },
            { name: 'Biella', code: 'BI' },
            { name: 'Cuneo', code: 'CN' },
            { name: 'Novara', code: 'NO' },
            { name: 'Torino', code: 'TO' },
            { name: 'Verbano-Cusio-Ossola', code: 'VB' },
            { name: 'Vercelli', code: 'VC' },
        ],
    },
    {
        name: 'Puglia',
        code: 'IT-75',
        provinces: [
            { name: 'Bari', code: 'BA' },
            { name: 'Brindisi', code: 'BR' },
            { name: 'Barletta-Andria-Trani', code: 'BT' },
            { name: 'Foggia', code: 'FG' },
            { name: 'Lecce', code: 'LE' },
            { name: 'Taranto', code: 'TA' },
        ],
    },
    {
        name: 'Sardegna',
        code: 'IT-88',
        provinces: [
            { name: 'Cagliari', code: 'CA' },
            { name: 'Nuoro', code: 'NU' },
            { name: 'Oristano', code: 'OR' },
            { name: 'Sassari', code: 'SS' },
            { name: 'Carbonia-Iglesias', code: 'CI' },
            { name: 'Olbia-Tempio', code: 'OT' },
            { name: 'Medio Campidano', code: 'VS' },
            { name: 'Ogliastra', code: 'OG' },
        ],
    },
    {
        name: 'Sicilia',
        code: 'IT-82',
        provinces: [
            { name: 'Agrigento', code: 'AG' },
            { name: 'Caltanissetta', code: 'CL' },
            { name: 'Catania', code: 'CT' },
            { name: 'Enna', code: 'EN' },
            { name: 'Messina', code: 'ME' },
            { name: 'Palermo', code: 'PA' },
            { name: 'Ragusa', code: 'RG' },
            { name: 'Siracusa', code: 'SR' },
            { name: 'Trapani', code: 'TP' },
        ],
    },
    {
        name: 'Toscana',
        code: 'IT-52',
        provinces: [
            { name: 'Arezzo', code: 'AR' },
            { name: 'Firenze', code: 'FI' },
            { name: 'Grosseto', code: 'GR' },
            { name: 'Livorno', code: 'LI' },
            { name: 'Lucca', code: 'LU' },
            { name: 'Massa-Carrara', code: 'MS' },
            { name: 'Pisa', code: 'PI' },
            { name: 'Prato', code: 'PO' },
            { name: 'Pistoia', code: 'PT' },
            { name: 'Siena', code: 'SI' },
        ],
    },
    {
        name: 'Trentino-Alto Adige, Trentino-Südtirol',
        code: 'IT-32',
        provinces: [
            { name: 'Bolzano', code: 'BZ' },
            { name: 'Trento', code: 'TN' },
        ],
    },
    {
        name: 'Umbria',
        code: 'IT-55',
        provinces: [
            { name: 'Perugia', code: 'PG' },
            { name: 'Terni', code: 'TR' },
        ],
    },
    { name: "Valle d'Aosta, Vallée d'Aoste", code: 'IT-23', provinces: [{ name: 'Aosta', code: 'AO' }] },
    {
        name: 'Veneto',
        code: 'IT-34',
        provinces: [
            { name: 'Belluno', code: 'BL' },
            { name: 'Padova', code: 'PD' },
            { name: 'Rovigo', code: 'RO' },
            { name: 'Treviso', code: 'TV' },
            { name: 'Venezia', code: 'VE' },
            { name: 'Vicenza', code: 'VI' },
            { name: 'Verona', code: 'VR' },
        ],
    },
] as const satisfies [Region, ...Region[]];
